<app-login-shell
  [mode]="'admin'"
  [loading]="loading"
  [showRecover]="false"
  [resetView]="true"
  [resetError]="resetError"
  [resetSaveError]="resetSaveError"
  [resetSuccess]="resetSuccess"
  (resetPassword)="onResetPassword($event)">
</app-login-shell>
